module.exports = __webpack_public_path__ + "static/Heebo-Medium-e2313ab74f5ac0a2025456771f26aee3.ttf";